import { loginApi } from "../firebase-api/login";
import { endPointUrl } from "../libs/fbConfig";
import Helper from "./helper";
import authHelper from "../okta/page"
import { godModeHeaders } from "./godMode";
const superagent = require("superagent");

/**
 * Base headers for every API call, plus the God Mode session id when one is
 * open. The server re-validates that id against the caller's Auth0 token on
 * every request and refuses mutations while the session is read-only, so this
 * header grants nothing on its own — it identifies the session to audit
 * against.
 */
function buildHeaders(authToken: any) {
    return {
        "Authorization": "Bearer " + authToken,
        "x-platform": "booking",
        ...godModeHeaders(),
    };
}





async function callApi(firebase: any, method: any, callUrl: any, requestPayload: any, unauthorized?: any, endPoint?: any, queryParameter?: any) {
    var endpoint = endPoint ? endPoint : endPointUrl;
    if (firebase) {
        callUrl = callUrl + (queryParameter ? "&" : "?") + "centerId=" + (firebase.sbDbName || firebase.centerId || Helper.getUrlParam("centerId"))
        requestPayload = Helper.getSuperagentBody(requestPayload, firebase);
    }
    let promise;
    let authToken: any

    if (!unauthorized) {
        authToken = await authHelper.getAuthToken()
    }
    switch (method.toLowerCase()) {
        case "post":
            promise = new Promise(function (resolve, reject) {
                superagent
                    .post(endpoint + callUrl)
                    .set("Content-Type", "application/json")
                    .set("accept", "json")
                    .set(buildHeaders(authToken)).send(requestPayload)
                    .end(function (err, res) {
                        if (err) {
                            reject(err);
                        } else {
                            resolve(res);
                        }
                    });
            });
            return promise;

        case "put":
            promise = new Promise(function (resolve, reject) {
                superagent
                    .put(endpoint + callUrl)
                    .set("Content-Type", "application/json")
                    .set("accept", "json")
                    .set(buildHeaders(authToken)).send(requestPayload)
                    .end(function (err, res) {
                        if (err) {
                            reject(err);
                        } else {
                            resolve(res);
                        }
                    });
            });
            return promise;

        case "get":
            promise = new Promise(function (resolve, reject) {
                superagent
                    .get(endpoint + callUrl)
                    .set("Content-Type", "application/json")
                    .set("accept", "json")
                    .set(buildHeaders(authToken))
                    .send(requestPayload)
                    .end(function (err, res) {
                        if (err) {
                            reject(err);
                        } else {
                            resolve(res);
                        }
                    });
            });
            return promise;

        case "delete":
            promise = new Promise(function (resolve, reject) {
                superagent
                    .delete(endpoint + callUrl)
                    .set("Content-Type", "application/json")
                    .set("accept", "json")
                    .set(buildHeaders(authToken))
                    .send(requestPayload)
                    .end(function (err, res) {
                        if (err) {
                            reject(err);
                        } else {
                            resolve(res);
                        }
                    });
            });
            return promise;
    }
}
export { callApi };
